import getCorrectionalFacilityId from './getCorrectionalFacilityId'

// Set up int/beta sgBaseUrl defaults for ease of use in storybook netlify environment
// Since the netlify build doesn't produce an env file, we have to hard-code them here
function getWindowDefaults() {
  const host = window.location.host

  let fallbackSgBaseUrl = ''
  if (host.includes('beta')) {
    fallbackSgBaseUrl = 'https://sg31b0.familysearch.org'
  } else if (host.includes('integration')) {
    fallbackSgBaseUrl = '`https://sg32i0.familysearch.org`'
  }

  return { sgBaseUrl: fallbackSgBaseUrl, geoData: {}, clientAppConfig: {} }
}

const SERVER_DATA = typeof window !== 'undefined' ? window.SERVER_DATA || getWindowDefaults() : {}

function GeoData() {
  ;[
    'country',
    'countryName',
    'countryRegion',
    'countryRegionName',
    'latitude',
    'longitude',
    'city',
    'postalCode',
  ].forEach((prop) => {
    Object.defineProperty(this, prop, {
      get() {
        return SERVER_DATA.geoData?.[prop]
      },
      enumerable: true,
    })
  })
}

function AppConfig() {
  Object.keys(SERVER_DATA?.clientAppConfig || {}).forEach((propName) => {
    Object.defineProperty(this, propName, {
      get: function get() {
        return SERVER_DATA?.clientAppConfig?.[propName]
      },
      enumerable: true,
    })
  })
}

// Warning: Some magic build steps will be happening here in your app with webpack and the DefinePlugin.
// The build step will look for the version in the package.json of @fs/zion-ui and @fs/react-scripts that
// the app is using, and then just inject those strings directly in place of CRA_MAGIC_ZION_UI_VERSION and
// CRA_MAGIC_REACT_SCRIPTS_VERSION
/* eslint-disable-next-line no-undef -- react-scripts will do a replace of this undefined variable with a string literal */
export const zionUiVersion = typeof CRA_MAGIC_ZION_UI_VERSION !== 'undefined' && CRA_MAGIC_ZION_UI_VERSION
export const reactScriptsVersion =
  /* eslint-disable-next-line no-undef -- react-scripts will do a replace of this undefined variable with a string literal */
  typeof CRA_MAGIC_REACT_SCRIPTS_VERSION !== 'undefined' && CRA_MAGIC_REACT_SCRIPTS_VERSION

export const {
  appName,
  appPath,
  cacheKey,
  initialDefaultEx,
  targetEnv,
  baseUrl,
  sgBaseUrl,
  splitioAuthKey,
  isLoggedIn,
  flagAttributes = {},
} = SERVER_DATA

// Export GeoData as an object so SERVER_DATA.geoData.* can be read at evaluation time and can be mocked in Storybook
export const geoData = new GeoData()

export const appConfig = new AppConfig()

export { mergeSentryConfig, sentryDefaults, sentryDSN, sentryDisabled, sentryRelease } from './sentry'

// Export the correctional facility ID
export const correctionalFacilityId = getCorrectionalFacilityId()
